import * as React from "react"
import { svgPathStyles } from "@digits-shared/components/SVG/svgIconStyles"
import { SvgBarChartSlash01 } from "@digits-shared/components/SVGIcons/line/BarChartSlash01.svg"
import { DigitsTooltip } from "@digits-shared/DesignSystem/Tooltip"
import colors from "@digits-shared/themes/colors"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import { TypeaheadResultDecorator } from "src/shared/components/Typeahead/sharedTypeahead"

const DisabledCategoryIcon = styled(SvgBarChartSlash01)`
  height: 16px;
  width: 16px;
  ${svgPathStyles(colors.secondary, 1.5)};
`

const DisabledIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;

  &:hover {
    background: ${colors.secondary20};
  }
`

const LabelContainer = styled.div<{ color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  height: 15px;
  padding: 0 4px;
  ${fonts.scale.label};
  font-weight: ${fonts.weight.heavy};
  color: ${({ color }) => color || colors.secondary};
  border: 1px solid ${({ color }) => color || colors.secondary};
`

export const ResultDecorator: React.FC<{ decorator: TypeaheadResultDecorator }> = ({
  decorator,
}) => {
  switch (decorator) {
    case TypeaheadResultDecorator.CategoryDisabled:
      return <DisabledCategoryDecorator />
    case TypeaheadResultDecorator.NewCategory:
      return <LabelContainer color={colors.aiBlue}>New</LabelContainer>
    default:
      return null
  }
}

export const DisabledCategoryDecorator: React.FC = () => (
  <DigitsTooltip content="Deactivated">
    <DisabledIconWrapper>
      <DisabledCategoryIcon />
    </DisabledIconWrapper>
  </DigitsTooltip>
)
